import React from 'react';
import Layout from '@codedrop/layout/esm/layout';

const Block2Col = ({
  firstCol,
  secondCol,
  variant = 'box'
}) => {
  return /*#__PURE__*/React.createElement(Layout, {
    className: "section--top-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block-2-col grid block-2-col--".concat(variant, " ").concat(variant === 'offset' ? 'background--firework-centered' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "block-2-col__1 grid__col grid--6-col"
  }, firstCol), /*#__PURE__*/React.createElement("div", {
    className: "block-2-col__2 grid__col grid--6-col"
  }, secondCol)));
};

Block2Col.displayName = 'Block2Column';
export default Block2Col;